module.exports = __webpack_public_path__ + "img/tax.27c220b9.svg";